module.exports = __webpack_public_path__ + "static/media/TS-asset3.09fd878d.svg";